import { useToasts } from "../../contexts/useToasts";
import { Toast } from "../Toast";

export const Toasts = () => {
  const { state: { toasts } } = useToasts();
  return <div className='flex flex-col space-y-4 fixed top-4 right-4'>
    {toasts.map((t, key) => <Toast {...{ ...t, key }} />)}
  </div>;
};